import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader";

const Dropdown = ({
	value,
	children,
	onItemSelect,
	overrideOnClick = false,
	render,
	extraClass = "",
	onOpen,
	onClose,
	loading = false,
	loadingText = null,
}: {
	value: any;
	children?: any[];
	onItemSelect?;
	overrideOnClick?: boolean;
	render?: Function;
	extraClass?: string;
	onOpen?: Function;
	onClose?: Function;
	loading?: boolean;
	loadingText?: string | null;
}) => {
	const [isOpen, setOpen] = useState(false);
	const node = useRef();

	//https://codesandbox.io/s/9o3lw5792w
	const handleClickOutside = e => {
		//@ts-ignore
		if (node.current.contains(e.target)) {
			// inside click
			return;
		}
		close();
	};

	useEffect(() => {
		//@ts-ignore
		if (isOpen !== null) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	const open = async () => {
		if (onOpen) {
			await onOpen();
		}

		setOpen(true);
	};

	const close = () => {
		if (onClose) {
			onClose();
		}

		setOpen(false);
	};

	return (
		<div className={`dropdown ${extraClass} ${isOpen ? "open" : "closed"}`} ref={node}>
			{loading ? (
				<Loader text={loadingText} />
				) : (
					<div className="dropdownBox" onClick={open}>
					{value}
					<div className="indicator" />
				</div>
			)}
			{isOpen ? (
				<div className="dropdownMenu">
					{React.Children.map(render ? render({ open, close, isOpen }) : children, (child, index) => {
						return (
							<div
								onClick={e => {
									if (!overrideOnClick) {
										onItemSelect(child.props.value);
										close();
									}
								}}
								className="cell"
								key={index}
							>
								{React.cloneElement(child, {
									...child.props,
								})}
							</div>
						);
					})}
				</div>
			) : null}
		</div>
	);
};

export default Dropdown;
